import moment from 'moment'

import { ReactComponent as DeviceIcon } from './device.svg'
import { ReactComponent as IpIcon } from './ip.svg'
import { ReactComponent as LinkIcon } from './link.svg'
import { ReactComponent as TimeIcon } from './time.svg'
import styles from './Tooltip.module.scss'

const CustomTooltip = ({ eventList }) => {
  return (
    <div className={styles.tooltip}>
      <div className={styles.eventTitle}>{eventList.reverse()[0].kind}</div>
      {eventList.reverse().map(event => (
        <div className={styles.event} key={event.kind + event.addedOn}>
          {event.addedOn && (
            <div className={styles.row}>
              <TimeIcon /> {moment(event.addedOn).format('MMM D, YYYY, hh:mm A')}
            </div>
          )}
          {(event.deviceName || event.browserName) && (
            <div className={styles.row}>
              <DeviceIcon />
              {event?.deviceName} / {event?.browserName}
            </div>
          )}
          {event.url && (
            <div className={styles.row}>
              <LinkIcon /> {event.url}
            </div>
          )}
          {event.ipAddress && (
            <div className={styles.row}>
              <IpIcon /> {event.ipAddress}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default CustomTooltip
